import { render, staticRenderFns } from "./ProductsHome.vue?vue&type=template&id=3e647ff3&"
import script from "./ProductsHome.vue?vue&type=script&lang=js&"
export * from "./ProductsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports